export default "__VITE_ASSET__BOiqHdh9__"